module.exports = __webpack_public_path__ + "static/media/Sepultura.3f9c9e21.jpg";